export const ROLE_ADMIN = 'admin'
export const ROLE_AGENT = 'agent'
export const ROLE_OWNER = 'owner'
